export const AudioModal = {
  en: {
    text: 'Would you like to enable audio?',
    yes: 'Yes',
    no: 'No',
  },
  ar: {
    text: 'هل ترغب في تفعيل الصوت',
    yes: 'نعم',
    no: 'كلا',
  },
};

export const OverlayMenu = {
  en: {
    instructions: 'Instructions',
  },
  ar: {
    instructions: 'التعليمات',
  },
};

export const WelcomeModal = {
  en: {
    topOne: 'Embark on a wonderful',
    topTwo: 'adventure and explore',
    topThree: 'Joyful Holidays',
    textFour: 'Collection',
    button: 'ENTER',
  },
  ar: {
    topOne: 'انطلق معنا في',
    topTwo: 'مغامرة استكشاف مذهلة',
    topThree: 'مجموعة الأعياد',
    textFour: 'السعيدة',
    button: 'ادخل',
  },
};

export const PDPContent = {
  en: {
    collection: 'Collection',
    addToCart: 'Add To Cart',
    santaWishlist: 'Santa Wishlist',
    quantity: 'ml',
    currency: 'AED',
    addedToWishlist: 'Item added to wishlist',
    addedToWishlistAlready: 'Already in wishlist',
  },
  ar: {
    collection: 'مجموعة',
    addToCart: 'أضف إلى الحقيبة',
    santaWishlist: 'قائمة أمنيات سانتا',
    quantity: 'مل',
    currency: 'د.إ',
    addedToWishlist: 'تمت إضافة المنتج إلى قائمة الأمنيات',
    addedToWishlistAlready: 'المنتج موجود بالفعل في قائمة الرغبات',
  },
};

export const WishlistContent = {
  en: {
    textOne: 'Ready choosing your dream gifts?',
    textTwo: 'Customise and send out your Santa Wishlist Postcard',
    button: 'Finalize Now',
  },
  ar: {
    textOne: 'هل أنت جاهز لاختيار هدايا أحلامك؟',
    textTwo: 'خصص بطاقة قائمة أمنيات سانتا البريدية وأرسلها',
    button: 'ضع اللمسات الأخيرة الآن',
  },
};

export const ArabicIngredients = {
  Lavender: 'لافندر',
  Immortelle: 'إمورتيل',
  Almond: 'اللوز',
  Shea: 'زبدة الشيا',
};

export const ProductComingSoon = {
  en: {
    title: 'Product Coming Soon',
    description: 'Stay tuned and return later to discover these skincare treasures from L’Occitane!',
  },
  ar: {
    title: 'المنتج قريبا',
    description: 'ابق على اتصال وارجع لاحقًا لاكتشاف كنوز العناية بالبشرة هذه من L’Occitane!',
  },
};

export const SubscribeModal = {
  en: {
    textOne: "Don't let the magic",
    textTwo: 'slip away',
    textThree: 'Subscribe now for exclusive updates, special offers, delivered straight to your inbox.',
    button: 'Subscribe',
  },
  ar: {
    textOne: 'حافظ على',
    textTwo: 'سحر العيد',
    textThree: '.اشترك الآن للحصول على تحديثات حصرية وعروض خاصة تصل مباشرة إلى بريدك',
    button: 'اشترك الآن',
  },
};

export const ArtOfGiftingModal = {
  en: {
    textOne: 'The Art of Gifting by L’Occitane',
    textTwo: 'Whether shopping in-store or online you can enjoy our free gift wrapping service!',
    textThree: 'SEARCH FOR MORE ITEMS',
  },
  ar: {
    textOne: 'فن إبداع الهدايا من لوكسيتان',
    textTwo: '!سواء اخترت التسوّق في المتجر أو عبر الإنترنت، استمتع بخدمتنا المجانية لتغليف الهدايا',
    textThree: 'ابحث عن المزيد من المنتجات',
  },
};

export const RewardInfoModal = {
  en: {
    textOne: 'Collect hidden items to reveal a suprise from us',
    oneItem: 'Find 1 more item',
    twoItem: 'Find 2 more items',
    thirdItem: 'Look for these 3 items',
  },
  ar: {
    textOne: 'جمّع الأغراض المخفية لتكشف عن مفاجأة',
    oneItem: 'ابحث عن غرض إضافي',
    twoItem: 'ابحث عن غرضين إضافيين',
    thirdItem: 'ابحث عن هذه الأغراض الثلاثة',
  },
};

export const CompletedModal = {
  en: {
    textOne: 'Mini-game completed!',
    textTwo: 'Enjoy extra 5% off the Holiday range online & in store.',
    textThree: 'Use Code:',
    textFour: 'copy',
    textFourSucc: 'copied',
    textFive: "Here's your well-deserved reward.",
    button: 'Open',
  },
  ar: {
    textOne: '!لقد أكملت اللعبة الصغيرة',
    textTwo: '.استمتع بخصم 5% إضافي على تشكيلة الأعياد أونلاين وشارك الفرح',
    textThree: ':استخدم الرمز',
    textFour: 'نسخ',
    textFourSucc: 'نجاح منسوخ',
    textFive: '.إليك جائزتك التي استحققتها عن جدارة',
    button: 'افتح',
  },
};

export const PostCardSentModal = {
  en: {
    textOne: 'Santa Postcard Sent!',
    button: 'KEEP EXPLORING',
  },
  ar: {
    textOne: 'تم إرسال بطاقة سانتا البريدية!',
    button: 'استمر بالاستكشاف',
  },
};

export const AddedToCartModal = {
  en: {
    textOne: 'Wishlist added to cart!',
    button: 'KEEP EXPLORING',
  },
  ar: {
    textOne: 'أضيفت قائمة الأمنيات إلى حقيبة التسوّق!',
    button: 'استمر بالاستكشاف',
  },
};

export const WhatToBringModal = {
  en: {
    textOne: 'What to bring?',
    textTwo:
      "You can choose to bring your own clean L'OCCITANE bottle or purchase an aluminum forever bottle at the store.",
  },
  ar: {
    textOne: 'ما الذي عليك إحضاره؟',
    textTwo: '.يمكنك إحضار عبوتك الخاصة والنظيفة من لوكسيتان أو شراء عبوة من الألومنيوم للاستخدام الدائم من المتجر',
  },
};

export const RetroHolidayModal = {
  en: {
    textOne: 'Retro Holiday Magic',
    textTwo:
      'Steve Wilson, a talented British illustrator takes us back to the roots of the brand and when it all started in 1976, with impactful vibrant ‘70s-inspired designs.',
  },
  ar: {
    textOne: 'سحر الأعياد الماضي',
    textTwo:
      '.يعيدنا الرسام البريطاني الموهوب ستيفن ويلسون إلى جذور علامتنا التجارية في بداياتها عام 1976، مع تصاميم تزخر بالألوان والحيوية مستوحاة من سبعينيات القرن الماضي',
  },
};

export const PostCardModal = {
  en: {
    left: {
      heading: "Share Your L'Occitane Wishes with Loved Ones!",
      wishlistPre: 'Your Name’s',
      wishlistName: 'Wishlist',
      productWishlist: 'Product Wishlist',
      next: 'Next',
      edit: 'Edit',
      optOne: {
        textOnePre: 'Dear',
        textOne: 'Recepient Name',
        textTwo: 'I have gone ahead and put together a Holiday wishlist to make your job easier this Holiday!',
        textThreeFirst: 'Love',
        textThreeSecond: 'Your Name',
        textThreeThird: 'xxx',
      },
      optTwo: {
        textOnePre: 'Dear',
        textOne: 'Recepient Name',
        textTwo:
          "For Holiday this year I wanted to drop a hint about my L'Occitane wishlist. I can't wait to see what you choose! Thanks in advance for your thoughtfulness.",
        textThreeFirst: 'Warm regards',
        textThreeSecond: 'Your Name',
        textThreeThird: 'xxx',
      },
      optThree: {
        textOnePre: 'Dear',
        textOne: 'Recepient Name',
        textTwo: "'Tis the season of gifts. Here's a glimpse of my wishlist.",
        textTwoSec: 'Thanks for making this holiday season special.',
        textThreeFirst: 'Warm wishes',
        textThreeSecond: 'Your Name',
        textThreeThird: 'xxx',
      },
      topButtonTextOne: 'Think i missed something?',
      topButtonTextTwo: 'Explore festive Gifts here:',
      button: 'enter virtual store',
      preview: 'Preview',
    },
    right: {
      heading: 'Personalize Your Santa Postcard',
      subHeading: 'Add Details:',
      recpName: 'Recepient Name',
      recpEmail: 'Recepient email address',
      yourName: 'Your Name',
      yourEmail: 'Your email address',
      chooseText: 'Choose text:',
      choosePattern: 'Choose pattern:',
      button: 'Send',
      buttonSending: 'Sending',
      tandc: 'I have read and agree to',
      tandcLink: 'Terms & Conditions',
    },
  },
  ar: {
    left: {
      heading: '!شارك أمنياتك من لوكسيتان مع أحبائك',
      wishlistPre: '(اسمك)',
      wishlistName: 'قائمة أمنيات للأعياد',
      productWishlist: 'قائمة أمنيات المنتج',
      next: 'التالي',
      edit: 'تعديل القائمة',
      optOne: {
        textOnePre: 'عزيزي/عزيزتي',
        textOne: '(اسم المتلقي)',
        textTwo: '!لقد وضعت لائحة أمنيات الأعياد بدلاً عنك لتسهيل عملك',
        textThreeFirst: 'مع محبتي',
        textThreeSecond: '(اسمك)',
        textThreeThird: '',
      },
      optTwo: {
        textOnePre: 'عزيزي/عزيزتي',
        textOne: '(اسم المتلقي)',
        textTwo: '!بمناسبة الأعياد هذا العام، هذه هي قائمة أمنياتي من لوكسيتان. بانتظار اختيارتك',
        textThreeFirst: 'مع محبتي',
        textThreeSecond: '(اسمك)',
        textThreeThird: '',
      },
      optThree: {
        textOnePre: 'عزيزي/عزيزتي',
        textOne: '(اسم المتلقي)',
        textTwo: '.إليك قائمة الهدايا التي اخترتها للاحتفال بالأعياد هذا العام',
        textTwoSec: '.شكراً لجعل موسم الأعياد مميز',
        textThreeFirst: 'مع محبتي',
        textThreeSecond: '(اسمك)',
        textThreeThird: '',
      },
      topButtonTextOne: 'هل تظن أنني نسيت شيئاً؟',
      topButtonTextTwo: ':استكشف هدايا العيد هنا',
      button: 'ادخل المتجر الافتراضي',
      preview: '!إعادة عرض القائم',
    },
    right: {
      heading: 'ضع لمستك الخاصة على بطاقة سانتا البريدية',
      subHeading: ':أضف التفاصيل',
      recpName: 'اسم المتلقي',
      recpEmail: 'عنوان بريد المتلقي الإلكتروني',
      yourName: 'اسمك',
      yourEmail: 'عنوان بريدك الإلكتروني',
      chooseText: 'اختر النص',
      choosePattern: 'اختر اللون',
      button: 'رسال',
      buttonSending: 'إرسال',
      tandc: 'لقد قرأت ووافقت على',
      tandcLink: 'الشروط والأحكام',
    },
  },
};
